import { string } from "prop-types";
import { useEffect, useRef, useState } from "react";

import useBreakpoint from "~hooks/useBreakpoint";

import { createConfettiFactory } from "./createConfetti";
import useMouseTrail from "./useMouseTrail"; // If you're using the custom hook

const MouseTrailWithConfetti = ({ elementQuerySelector }) => {
  const [targetElement, setTargetElement] = useState(null);
  const createConfettiRef = useRef(createConfettiFactory());
  const createConfetti = createConfettiRef.current;
  const { isUpToSM } = useBreakpoint();

  useMouseTrail(targetElement);

  useEffect(() => {
    if (isUpToSM()) {
      setTargetElement(null);
      return;
    }

    const element = document.querySelector(elementQuerySelector);

    if (!element) {
      return;
    }

    setTargetElement(element);

    const handleClick = (event) => {
      createConfetti(event.clientX, event.clientY, element);
    };

    element.addEventListener("click", handleClick);

    return () => {
      element.removeEventListener("click", handleClick);
    };
  }, [isUpToSM, elementQuerySelector, createConfetti]);

  // This should actually be a hook since it never returns any JSX
  // but because it works and is just temporary code, we can leave it like this
  return null;
};

MouseTrailWithConfetti.propTypes = {
  elementQuerySelector: string.isRequired,
};

export default MouseTrailWithConfetti;
